<template lang="pug">
div
  CommonHeader(v-if="!isDouyinMP" title="")
  .container(
    v-if="!displayDefault&&!showLoading"
    :class="{'is-douyin-mp':isDouyinMP, 'is-shadow-monthly-card':isShadowCardMonthly}"
  )
    .bg-container(
      :style="{backgroundImage: `url(${relBackgroundImg})`}"
    )
    //- 两轮骑行卡头图标题（仅在两轮骑行卡场景下展示，其他场景标题直接焊死在底图上）
    PageMainTitle(v-if='cardGuid && externalCardInfo.pageTitle' :title="externalCardInfo.pageTitle")
    .middle-container
      //- 新版，前端根据数据展示（两轮骑行卡）
      SimpleCardInfo(
        v-if="cardGuid && !hasScene"
        :cardInfo="externalCardInfo"
        :signIn="signIn"
      )
      //- 不补贴复购场景（使用动态组件）
      component(
        v-else-if="hasScene"
        :is="currentCardComponent"
        :signIn="signIn"
        :displayImgs="displayImgs"
      )
      //- 原有影子卡场景（保持不变）
      OldCardInfo(
        v-else
        :signIn="signIn && !hasScene"
        :goodsTitleImg="displayImgs.goodsTitleImg"
        :middleContentImg="middleContentImg"
        :isShadowCardMonthly="isShadowCardMonthly"
      )
      .sign-in-action(v-if="signIn" @click="toUseHandle")
        .go-cycle {{isDouyinMP?'去哈啰App骑行' : '扫码骑行'}}
    .action-box(v-if="!signIn")
      template(v-if="!hasScene")
        //- 连续包月状态 (注意⚠️⚠️⚠️⚠️ 普通卡连续包月的实验已经推全，线上不再有普通卡连续包月的情况，由于现存实验较多，后续如果逻辑过于复杂，可以跟产品商量将推全的代码下掉)
        .monthly-box(v-if="actionButtonDisplay === 'monthly_card'")
          .button-content
            ActionButton(
              width="1.45rem"
              :content="`开通1个月¥${onceGood.salePrice}`"
              :subContent="`日常价¥${onceGood.originalPrice}`"
              buttonType="normal"
              @click="monthlyBuyBefore('buyOnce')"
            )
            ActionButton(
              width="1.75rem"
              :content="`连续包月¥${monthlyGood.promoPrice}`"
              :subContent="`次月起¥${monthlyGood.salePrice}/月续费`"
              buttonType="active"
              @click="monthlyBuyBefore('buyMonthly')"
            )
            //- 隐私协议组件
            //- (暂时注释，请勿删除，后续如果有合规问题，再打开)
          //- PrivacyPolicy(v-model="agreePrivacy")
        //- 签约/支付状态(影子卡激活单个按钮)
        .normal-box(v-if="actionButtonDisplay === 'rake_card'")
          .subsidy-price-container(:style="`margin-top: ${signIn ? '0.6rem' : '0.07rem'}`")
            .subsidy
              .reduce-num(v-if="cardGuid")
                span -
                span.num {{externalCardInfo.subsidyPrice}}
                span 元
              img.subsidy-pic(:src="subsidyPic" v-if="!signIn")
            .btn-wrapper(
              v-flash="!signIn ? {shineLight:true,boom:true,scale: 0.9} : {shineLight:false}"
              :class="signIn ? 'special-btn' : 'normal-btn'"
            )
              .text-wrapper(v-if="!signIn" @click="signAndPayOrActive")
                //- 按钮第一行大文案
                .price-wrapper
                  .btn-active-text(v-if="cardGuid")
                    highlightText(
                      :text='externalCardInfo.buttonMainTitle'
                      :normalStyle="btnNormalStyle"
                      :highlightStyle="btnHighlightStyle"
                    )
                  .btn-active-text(v-else-if="planInfo.hasCard")
                    highlightText(
                      :text='planInfo.buttonMainTitle'
                      :normalStyle="btnNormalStyle"
                      :highlightStyle="btnHighlightStyle"
                    )
                  .btn-price-text(v-else)
                    span.fix-text 补贴后 仅需
                    span {{planInfo.salePrice}}
                    span.fix-text 元{{planInfo.participated?'起':'抢'}}
                //- 按钮第二行小文案
                .btn-inform-text(
                  v-if="cardGuid && externalCardInfo.buttonSubtitle"
                ) {{externalCardInfo.buttonSubtitle}}
                .btn-inform-text(
                  v-else-if="planInfo.hasCard && planInfo.buttonSubTitle"
                ) {{planInfo.buttonSubTitle}}
                .btn-inform-text(v-else) 开通抖音先骑后付，骑车单单1分钱
          .active-last-date(v-if="!signIn")
            span(v-if="planInfo.hasCard && planInfo.ruleDescription") {{planInfo.ruleDescription}}
            span(v-else) 首次开通抖音免密支付用户享更多优惠
          img.notice(v-if="planInfo.hasCard" src="https://m.hellobike.com/resource/gallery/847/s2vvNfFk4w.png")
        //- 影子卡连续包月状态
        .shadow-monthly-box(v-if="actionButtonDisplay === 'shadow_monthly_card'")
          //- 按钮内容
          .button-content
            ActionButton.left-button(
              width="1.25rem"
              :content="planInfo.buttonMainTitle"
              :subContent="planInfo.buttonSubTitle"
              buttonType="normal"
              @click="monthlyBuyBefore('shadowBuyOnce')"
            )
            ActionButton.right-button(
              v-flash="{shineLight:true,boom:true,scale: 0.9}"
              width="1.75rem"
              :content="planInfo.monthlyButtonMainTitle"
              :subContent="planInfo.monthlyButtonSubtitle"
              buttonType="active"
              @click="monthlyBuyBefore('shadowBuyMonthly')"
            )
      //- 不补贴复购场景按钮（使用动态组件）
      component(
        v-else
        :is="currentButtonComponent"
        :content="planInfo"
        @click="senceHandler"
      )
        //- 隐私协议组件
        //- (暂时注释，请勿删除，后续如果有合规问题，再打开)
        //- PrivacyPolicy.privacy-policy(v-model="agreePrivacy")
    .shadow-monthly-tips(v-if="isShadowCardMonthly && !signIn")
      p.title 关于单车1分骑行卡
      p.text 每单前120分钟 仅需0.01元
        span  超出部分按照单次计费为准
      p.text 哈啰APP专享
        span  限哈啰APP扫码开锁骑行
    //- 影子卡如何激活示意图
    img.shadow-notice(v-if="isShadowCardMonthly  && !signIn" src="https://m.hellobike.com/6fd6a6b6_Group_1707484300.png")
    //- 售卡模块
    CardSaleModel(
      v-if="signIn"
      :filter-goods="filterGoods"
      :goods-tag-mapping="goodsTagMapping"
      :category-ids="extraInfo.categoryIds"
      :adsource="adsource"
      :spu-id="spuId"
    )
    RetainDialog(
      :cardInfo="externalCardInfo"
      :isTwCard="!!cardGuid"
      :showDialog="showRetainDialog"
      :retainPopupImg="displayImgs.retainPopupImg"
      :handleBack="handleBack"
      @close="handleCloseRetain"
    )
  //- 加载页
  LoadingPage(v-if="showLoading")
  //- 兜底页
  ErrorPage(
    v-if="displayDefault"
    :isLogin="isLogin"
    :haCode="extraInfo.haCode"
    :msg="msg"
    :code="code"
    @refresh="getMarketInfo"
  )

</template>
<script>
// 访问链接
// m.hellobike.com/AppPlatformH5/fat/latest/index.html#/newClient
// 访问参数：         cardType -> bike：单车、ebike：助力车、monthlyBike：连续包月
//                  adsource -> 渠道参数
//                  shadowCardId -> 影子卡批次号
//                  spuId -> 卡券的商品id，如果是从卡券商城跳转过来的则必传，否则不传
//                  cardGuid -> 两轮卡的guid，（两轮卡售卖场景必传）
//                  businessType -> 两轮卡的业务类型，1：单车，2：助力车（两轮卡售卖场景必传）
//                  isExternalCard -> 是否是通过微信两轮卡激活页复制哈口令过来的，true/false
import CommonHeader from '@/components/common-header';
import {
  getTiktokPlanInfo,
} from '@/api/tiktokSign';
import {
  getTokenAndLocation,
  commonGoLink,
  copyText,
  debounce,
} from '@/utils';
import { getVersion, getSystemCode, getEnv } from '@/utils/systemCode';
import dayjs from 'dayjs';
import { Navigator } from '@hb/h5-navigator';
import Toast from '@/components/toast';
import { Storage } from '@/utils/storage';
import { env, Native } from '@hb/hbridge';
import Loading from '@/components/loading';
import highlightText from '@/components/highlight-text.vue';
import LoadingPage from './loadingPage.vue';
import ErrorPage from './errorPage.vue';
import openReadModal from './components/read-modal/index';
import openLowVersionModal from './components/low-version-modal/index';
import CusRadio from './components/cus-radio';
import CardSaleModel from './components/card-sale-model.vue';
import RetainDialog from './components/retain-dialog.vue';
import PrivacyPolicy from './components/privacy-policy.vue';
import ActionButton from './components/action-button.vue';
import { ParamsUtil } from '../../utils/params';
import { safeGet } from '../../utils';
import SimpleCardInfo from './components/simple-card-info.vue';
import OldCardInfo from './components/old-card-info.vue';
import NoSubsidyRepurchaseCardInfo from './components/no-subsidy-card-info.vue';
import NoSubsidyRepurchaseButton from './components/no-subsidy-button.vue';
import SPM from './common/spm';
import PageMainTitle from './components/page-main-title.vue';
import {
  CARD_TYPE,
  PROTOCOL_URL,
  CHARGE_TYPE,
  ORDER_TYPE,
  ACTION_TYPE,
  SCENE_TYPE,
  COMPONENT_MAP,
  BUTTON_MAP,
} from './common/const';
import {
  createOrder,
  callDouYinPayAndSign,
  callDouYinSign,
  queryDouYinSignResult,
  activeCardHelper,
} from './common/helper';

export default {
  components: {
    CommonHeader,
    ErrorPage,
    LoadingPage,
    CusRadio,
    CardSaleModel,
    highlightText,
    RetainDialog,
    PrivacyPolicy,
    ActionButton,
    SimpleCardInfo,
    OldCardInfo,
    NoSubsidyRepurchaseCardInfo,
    NoSubsidyRepurchaseButton,
    PageMainTitle,
  },
  data() {
    return {
      // 是否展示兜底页
      displayDefault: false,
      // 是否展示loading页
      showLoading: false,
      dataInfo: {},
      // 是否登录
      isLogin: false,
      msg: '',
      code: null,
      adsource: '',
      // 是否是抖音小程序环境
      isDouyinMP: getEnv().isDouyinMP,
      // 抖音小程序签约商品tag
      productTagForDySign: '',
      // 抖音小程序签约商品场景
      bizSceneForDySign: '',
      displayImgs: {},
      planInfo: {},
      // 抖音小程序签约并支付成功回调参数payWithSignSuccess=1则代表成功，仅在抖音小程序中存在
      payWithSignSuccess: false,
      // 影子卡id，卡列表过来的时候链接上会有该参数
      shadowCardId: '',
      // 影子卡信息
      shadowCardInfo: {},
      // 影子卡激活成功
      signIn: false,
      // 卡类型枚举
      CARD_TYPE,
      // 卡类型，默认单车（bike）
      cardType: CARD_TYPE.BIKE,
      // 是否同意隐私协议（暂时隐藏协议，默认同意，后续如果要展示协议，再设为false）
      agreePrivacy: true,
      // 显示阅读协议弹窗
      showReadModal: false,
      // 连续包月商品
      monthlyGood: {},
      // 单月购买商品
      onceGood: {},
      // 售卡模块spuId与goodsTag映射关系
      goodsTagMapping: null,
      // 活动接口返回的扩展信息
      extraInfo: {},
      // 卡券的商品id
      spuId: '',
      // 是否开通了连续包月
      monthlySignIn: false,
      // 按钮文案普通样式
      btnNormalStyle: {
        fontSize: '0.18rem',
        fontWeight: 600,
        marginBottom: '0.03rem',
        color: '#fff',
      },
      // 按钮文案高亮样式
      btnHighlightStyle: {
        fontSize: '0.24rem',
        color: '#fff',
        fontWeight: 600,
      },
      // 实验名称（对照组、实验组）
      experimentId: '',
      // 抖音小程序内，签约成功后点击去骑行的时候，需要复制的哈口令
      rideBikeHaCode: '',
      // 是否展示挽留弹窗
      showRetainDialog: false,
      // 挽留弹窗图片
      retainPopupImg: '',
      // 影子卡签约方式判断
      shadowCardSignType: 'sign', // sign：签约，payAndSign：签约并支付
      // 影子卡支付签约实验名称
      shadowCardSignExperimentName: '',
      // 是否为影子卡连续包月
      isShadowCardMonthly: false,
      // 命中连续包月的时候，影子卡购买商品
      shadowCardOneGoods: {},
      // 影子卡连续包月商品
      shadowCardMonthlyGoods: {},
      // 操作类型 影子卡支付并签约、影子卡连续包月购买并激活、普通卡单次购买、普通卡连续包月购买详见 ACTION_TYPE
      actionType: '',
      // 展示卡信息
      externalCardInfo: {
        // buttonMainTitle: '立即激活',
        // buttonSubtitle: '开通抖音先骑后付，骑车单单1分钱',
        // pageTitle: '哈啰送你|{30天}单车补贴',
        // cardMainTitle: '单车30天卡 单单仅需1分钱',
        // cardTitle: '哈啰单车骑行卡  单单仅需0.01元',
        // cardSubTitle: '{30}天{12}次',
        // cardPrice: 35,
        // useTip: '全国通用',
        // isAppOnly: true,
        // useDesc: [
        //   '{限哈啰APP} 扫码开锁骑行',
        //   '{前120分钟} {仅需0.01元} 超出部分按照单次计费为准',
        // ],
        // subsidyPrice: 8.99,
      },
      // 两轮卡的guid
      cardGuid: '',
      // 两轮卡的业务类型
      businessType: '',
      // 是否是通过微信两轮卡激活页复制哈口令过来的，true/false
      isExternalCard: false,
      // 用户ID
      userNewId: '',
    };
  },
  computed: {
    // 头部背景图
    relBackgroundImg() {
      // 如果是两轮骑行卡，则头图上的标题为动态的，只需要写死的底图
      if (this.cardGuid) {
        // 两轮业务场景为助力车时，展示助力车底图
        if (this.businessType === '2') {
          return this.isDouyinMP ? 'https://m.hellobike.com/83998eb770.jpg' : 'https://m.hellobike.com/f04529329b.jpg';
        }
        // 两轮业务场景为单车时，展示单车底图
        return this.isDouyinMP ? 'https://m.hellobike.com/fa9a80ed3e.jpg' : 'https://m.hellobike.com/1ce18aaacf.jpg';
      }
      return this.isDouyinMP ? this.displayImgs.dyBackgroundImg : this.displayImgs.backgroundImg;
    },
    // 过滤出正常的商品
    filterGoods() {
      return (this.planInfo.goodsList || []).map((item) => item.spuId);
    },
    // 操作按钮展示逻辑
    actionButtonDisplay() {
      // 影子卡连续包月卡
      if (this.isShadowCardMonthly) {
        return 'shadow_monthly_card';
      }
      // 购买普通1分钱卡或单个影子卡
      if (this.cardType === CARD_TYPE.BIKE || this.cardType === CARD_TYPE.E_BIKE) {
        return 'rake_card';
      }
      // 购买连续包月卡
      if (this.cardType === CARD_TYPE.MONTHLY_BIKE) {
        return 'monthly_card';
      }
      // 默认展示购买普通1分钱卡
      return 'rake_card';
    },
    // 中间内容图片
    middleContentImg() {
      // 未签约的时候，展示商品图片
      if (!this.signIn) {
        return this.displayImgs.goodsImg;
      }
      // 若已签约，且行为是影子卡连续包月激活，则展示影子卡连续包月激活图片
      if (this.actionType === ACTION_TYPE.SHADOW_BUY_MONTHLY) {
        return this.displayImgs.shadowActiveMonthlyImg;
      }
      // 若已签约，且行为不是影子卡连续包月激活，则展示激活图片
      return this.displayImgs.activateImg;
    },
    // 补贴图片
    subsidyPic() {
      // 两轮骑行卡场景下，限时补贴价为动态的，所以背景只需要底图，补贴价由前端写上去
      // 其他场景下，补贴图片为固定图片，补贴价焊死在底图上
      if (this.cardGuid) {
        return 'https://m.hellobike.com/9d5a4acc74.png';
      }
      return this.displayImgs.reducedImg;
    },
    // 动态组件选择逻辑（仅用于不补贴复购场景）
    currentCardComponent() {
      const type = this.planInfo && this.planInfo.sceneType;
      const scene = type && SCENE_TYPE[type];
      return COMPONENT_MAP[scene];
    },
    hasScene() {
      const type = this.planInfo && this.planInfo.sceneType;
      return !!(type && SCENE_TYPE[type]);
    },
    // 动态按钮组件选择逻辑
    currentButtonComponent() {
      const type = this.planInfo && this.planInfo.sceneType;
      const scene = type && SCENE_TYPE[type];
      return BUTTON_MAP[scene];
    },
    // 上报用spuId：优先使用URL参数，如果没有则从goodsList中获取
    reportSpuId() {
      if (this.spuId) {
        return this.spuId;
      }
      return safeGet(this.planInfo, 'goodsList.0.spuId', '');
    },
  },
  async created() {
    const {
      cardType = CARD_TYPE.BIKE,
      adsource,
      // 抖音小程序版本号，仅在抖音小程序中存在
      dyVersion,
      payWithSignSuccess,
      shadowCardId,
      spuId,
      cardGuid,
      businessType,
      isExternalCard,
      batchCode,
    } = ParamsUtil.getParams(window.location.href);
    this.showLoading = true;
    const { token, cityCode, userNewId } = await getTokenAndLocation();
    this.cityCode = cityCode;
    this.userNewId = userNewId;
    this.cardType = cardType;
    this.adsource = adsource;
    this.payWithSignSuccess = payWithSignSuccess;
    this.shadowCardId = shadowCardId;
    this.spuId = spuId;
    this.isLogin = !!token;
    this.cardGuid = cardGuid;
    this.businessType = businessType;
    this.isExternalCard = isExternalCard;
    this.batchCode = batchCode;
    // 如果抖音版本低于6.91.5，则暂时兜底，你不符合参与条件（由于抖音小程序灰度发布的原因，部份用户的小程序版本可能不是最新的，无法走签约流程，所以展示兜底 日期：2025-06-30）
    if (dyVersion < '6.91.5') {
      this.displayDefault = true;
      this.showLoading = false;
      return;
    }
    if (!this.isLogin) {
      this.displayDefault = true;
      this.showLoading = false;
    }
    this.getMarketInfo();
    // 页面离开埋点x
    if (window.history && window.history.pushState) {
      // document.addEventListener('visibilitychange', this.handlePageVisibilityChange);
      window.addEventListener('popstate', () => {
        if (this.displayDefault) {
          return;
        }
        SPM.clickButton.platform_tt_card_finish_back.call(this);
        this.handlePopstate();
      }, false);
    }
  },
  beforeDestroy() {
    // document.removeEventListener('visibilitychange', this.handlePageVisibilityChange);
    window.removeEventListener('popstate', this.handlePopstate, false);
  },
  methods: {
    /**
     * 获取活动信息
     */
    async getMarketInfo() {
      this.payAndSignLoading = false;
      this.showLoading = true;
      const { data, code, msg } = await this.fetchActivityDataHandle();
      this.showLoading = false;
      this.dataInfo = data || {};
      this.planInfo = safeGet(data, 'planInfo', {});
      this.displayImgs = safeGet(data, 'planInfo.displayImgs', {}); // 页面展示的图片资源链接
      this.displayDefault = data.displayDefault; // 是否显示兜底界面
      this.shadowCardInfo = this.planInfo.cardInfo || {};
      this.shadowCardId = this.shadowCardInfo.propertyId;
      this.extraInfo = this.dataInfo.extraInfo || {};
      this.goodsTagMapping = this.extraInfo.goodsTagMapping || {};
      this.cardType = this.planInfo.cardType || CARD_TYPE.BIKE;
      this.rideBikeHaCode = this.planInfo.rideBikeHaCode || '';
      this.experimentId = this.planInfo.experimentId || '';
      this.shadowCardSignExperimentName = this.planInfo.shadowCardSignExperimentName || '';
      this.shadowCardSignType = this.planInfo.shadowCardSignType || 'sign';
      this.isShadowCardMonthly = this.planInfo.isShadowCardMonthly;
      if (this.planInfo.hasCard && this.shadowCardInfo.activated) {
        this.signIn = true;
      }
      (this.planInfo.goodsList || []).forEach((good) => {
        // 普通卡连续包月商品处理
        if (this.cardType === CARD_TYPE.MONTHLY_BIKE) {
          if (good.monthlyGoods) {
            // 连续包月商品
            this.monthlyGood = good;
          } else {
            // 单月购买商品
            this.onceGood = good;
          }
        }
        // 影子卡连续包月商品处理
        if (this.isShadowCardMonthly) {
          if (good.goodsType === 'monthly') {
            this.shadowCardMonthlyGoods = good;
          } else if (good.goodsType === 'payAndSign') {
            this.shadowCardOneGoods = good;
          }
        }
      });
      this.productTagForDySign = safeGet(this.planInfo, 'payParams.productTagForDySign', '');
      this.bizSceneForDySign = safeGet(this.planInfo, 'payParams.biz_scene', '');
      this.defaultGoodsTag = safeGet(this.planInfo, 'payParams.productTagForDySign', '');
      this.defaultBizScene = safeGet(this.planInfo, 'payParams.biz_scene', '');
      this.monthlySignIn = this.dataInfo.monthlySignIn;
      this.externalCardInfo = safeGet(this.planInfo, 'externalCardInfo', {});
      this.code = code;
      this.msg = msg;
      // code 103 表示未登录
      if (code === 103) {
        this.isLogin = false;
      }
      // h5链接上带有payWithSignSuccess=1，则表示签约成功，将页面状态替换成签约成功状态(专门针对抖音小程序支付并签约成功)
      if (this.payWithSignSuccess === '1') {
        this.payWithSignSuccessHandle({
          showToast: true,
          actionType: ACTION_TYPE.NORMAL_PAY_AND_SIGN,
        });
      }
      if (!this.displayDefault) {
        this.entryExpose();
        this.getRetainPopupWindow();
      }
    },
    entryExpose() {
      // 抖音1分钱卡活动页页面进入&页面退出
      SPM.pageView.platform_tt_card.call(this);
      if (this.cardType === CARD_TYPE.MONTHLY_BIKE && !this.hasScene) {
        // 连续包月模块模块曝光
        SPM.moduleExpose.platform_tt_card_monthly.call(this);
      }
      // 立即激活按钮曝光
      if (!this.signIn && !this.hasScene) {
        if (this.cardGuid) {
          // 两轮卡激活按钮模块曝光
          SPM.moduleExpose.platform_tt_card_ridecard.call(this);
        } else if (this.planInfo.hasCard) {
          if (this.shadowCardSignType === 'payAndSign') {
            // 影子卡支付激活按钮模块曝光
            SPM.moduleExpose.platform_tt_card_activate_pay.call(this);
          } else {
            // 影子卡激活按钮模块曝光
            SPM.moduleExpose.platform_tt_card_activate.call(this, 0);
          }
        }
      }
      if (this.actionButtonDisplay === 'shadow_monthly_card' && !this.hasScene) {
        // 升级连续包月卡模块模块曝光
        SPM.moduleExpose.platform_tt_card_monthlyUpdate.call(this);
        // 升级连续包月模块-左侧影子卡模块模块曝光
        SPM.moduleExpose.platform_tt_card_monthlyUpdate_shadow.call(this);
      }
      // 不补贴复购场景模块曝光
      if (this.hasScene && this.planInfo.sceneType === SCENE_TYPE.NO_SUBSIDY_REPURCHASE) {
        // 不补贴复购页面购卡优惠曝光
        SPM.moduleExpose.platform_tt_card_noSubsidyRepurchase_discount.call(this);
      }
    },
    /**
     * 获取活动数据请求处理函数
     * 处理签约回调的情况以及异常状态
     */
    async fetchActivityDataHandle() {
      const {
        token, cityCode, adCode, userGuid,
      } = await getTokenAndLocation();
      let res = {};
      try {
        // 签约成功后，再次回到签约h5页面，产品需求是页面不刷新，只改变状态
        // 一旦重新请求接口，则接口就会返回兜底信息导致页面显示兜底内容，所以需要将接口数据缓存
        // 小程序跳转会导致页面刷新，小程序回退又无法给web-view的h5传递参数
        // 所以在回调的时候给h5链接新增参数payWithSignSuccess=1，h5根据该参数判断是否从storage中获取上一次去请求缓存的参数
        if (this.payWithSignSuccess === '1') {
          res = Storage.getItem('newClientMarketInfo');
        } else {
          res = await getTiktokPlanInfo({
            userGuid,
            token,
            systemCode: getSystemCode(),
            version: await getVersion(),
            planType: 'tiktok_sign',
            cardType: this.cardType,
            batchCode: this.batchCode,
            cityCode,
            adCode,
            adSource: this.adsource,
            cardId: this.shadowCardId,
            spuId: this.spuId,
            cardGuid: this.cardGuid, // 两轮卡的guid
            businessType: this.businessType, // 两轮卡的业务类型
            isExternalCard: !!this.isExternalCard, // 是否是通过微信两轮卡激活页复制哈口令过来的，true/false
          });
        }
        res.data = res.data || {
          displayDefault: true,
        };
        Storage.setItem('newClientMarketInfo', res);
      } catch (e) {
        return {
          data: {
            displayDefault: true,
          },
          // 非0code，除特殊情况都会到catch，catch分支下真实的response会绑定到window.__error上
          code: safeGet(window, '__error.code', null),
          msg: safeGet(window, '__error.msg', e.message),
        };
      }
      return res;
    },
    /**
     * 签约并支付或者激活影子卡
     */
    signAndPayOrActive: debounce(function signAndPayOrActive() {
      if (!safeGet(this.planInfo, 'payParams', null)) {
        Toast.show('操作失败，缺少支付参数');
        return;
      }
      // 有影子卡或者两轮骑行卡，则走激活或者支付激活，否则走签约支付购卡
      if (this.planInfo.hasCard || this.cardGuid) {
        this.activeHandler(this.planInfo.goodsList);
        if (this.cardGuid) {
          // 两轮卡激活按钮模块点击
          SPM.clickButton.platform_tt_card_ridecard.call(this);
        } else if (this.shadowCardSignType === 'payAndSign') {
          // 影子卡支付激活按钮模块点击
          SPM.clickButton.platform_tt_card_activate_pay.call(this);
        } else {
          // 影子卡激活按钮模块点击
          SPM.clickButton.platform_tt_card_activate.call(this);
        }
      } else {
        this.payAndSign({
          orderType: ORDER_TYPE.NORMAL,
          goodsList: this.planInfo.goodsList,
          payAmount: this.planInfo.originalPrice,
          chargeType: CHARGE_TYPE.PAY_AND_SIGN,
          actionType: ACTION_TYPE.NORMAL_PAY_AND_SIGN,
        });
      }
    }, 300),
    /**
     * 购买一个月或者连续包月前置判断
     * 1、判断抖音小程序内，连续包月场景不支持，复制哈口令引导到app
     * 2、判断app版本号是否低于6.93.0，低于这个版本的，阻断后续流程，引导用户去下载
     * 3、判断是否同意隐私协议，未同意则引导打开隐私协议
     * 4、已同意隐私协议，则直接执行购买逻辑
     * @param {string} action 当前点击的是哪个按钮buyOnce：购买1个月，buyMonthly：连续包月
     */
    monthlyBuyBefore: debounce(async function monthlyBuyBefore(action = 'buyOnce') {
      switch (action) {
        case 'buyOnce':
          // 连续包月模块-左侧商品模块点击
          SPM.clickButton.platform_tt_card_monthly.call(this, 1);
          break;
        case 'buyMonthly':
          // 连续包月模块-右侧商品模块点击
          SPM.clickButton.platform_tt_card_monthly.call(this, 2);
          break;
        case 'shadowBuyOnce':
          // 升级连续包月卡模块模块点击
          SPM.clickButton.platform_tt_card_monthlyUpdate_shadow.call(this);
          break;
        case 'shadowBuyMonthly':
          // 影子卡-升级连续包月模块-左侧影子卡模块模块点击
          SPM.clickButton.platform_tt_card_monthlyUpdate.call(this);
          break;
        default:
          break;
      }
      if (action === 'buyMonthly' || action === 'shadowBuyMonthly') {
        // 抖音小程序暂时不支持连续包月组件
        if (this.isDouyinMP) {
          if (this.extraInfo.haCode) {
            Toast.show('口令码已复制至剪贴板，请前往哈啰App操作');
            copyText(this.rideBikeHaCode);
          } else {
            Toast.show('请前往哈啰App操作');
          }
          return;
        }
        // 连续包月要求app版本号高于6.93.0，低于这个版本的，阻断后续流程，引导用户去下载
        const lowVersion = await getVersion() < '6.93.0';
        if (lowVersion) {
          // 连续包月升级弹窗模块曝光
          SPM.moduleExpose.platform_tt_card_toupdate.call(this);
          openLowVersionModal({
            haCode: this.extraInfo.haCode,
            confirm() {
              // 连续包月升级弹窗模块点击
              SPM.clickButton.platform_tt_card_toupdate.call(this);
            },
          });
          return;
        }
        // 未同意隐私协议，先弹窗引导打开隐私协议
        if (!this.agreePrivacy) {
          // 连续包月协议确认模块曝光
          SPM.moduleExpose.platform_tt_card_monthly_confirm.call(this);
          openReadModal({
            readOk: () => {
              // 连续包月协议确认模块点击
              SPM.clickButton.platform_tt_card_monthly_confirm.call(this);
              this.agreePrivacy = true;
              this.monthlyBuyAction(action);
            },
          });
          return;
        }
      }
      // 已同意隐私协议，直接执行购买逻辑
      this.monthlyBuyAction(action);
    }, 300),
    /**
     * 购买一个月或者连续包月动作处理
     * @param {string} action 当前点击的是哪个按钮buyOnce：购买1个月，buyMonthly：连续包月
     */
    monthlyBuyAction(action = 'buyOnce') {
      // 影子卡激活或支付激活
      if (action === 'shadowBuyOnce') {
        this.shadowBuyOnce({
          goods: this.shadowCardOneGoods,
        });
      }
      // 影子卡连续包月购买并激活
      if (action === 'shadowBuyMonthly') {
        this.shadowBuyMonthly({
          goods: this.shadowCardMonthlyGoods,
          actionType: ACTION_TYPE.SHADOW_BUY_MONTHLY,
        });
      }
      // 普通卡单次购买
      if (action === 'buyOnce') {
        this.buyOnce({ goods: this.onceGood, actionType: ACTION_TYPE.BUY_ONE_MONTH });
      }
      // 普通卡连续包月购买
      if (action === 'buyMonthly') {
        this.buyMonthly({ goods: this.monthlyGood, actionType: ACTION_TYPE.BUY_MONTHLY });
      }
    },
    /**
     * 骑行卡开通一个月
     */
    buyOnce({ goods, actionType }) {
      this.actionType = actionType;
      // 创建订单，并调用支付签约组件
      this.payAndSign({
        orderType: ORDER_TYPE.NORMAL,
        goodsList: [goods],
        payAmount: goods.salePrice,
        chargeType: CHARGE_TYPE.PAY_AND_SIGN,
        actionType,
      });
    },
    /**
    * 骑行卡连续包月
    */
    buyMonthly({ goods, actionType }) {
      this.actionType = actionType;
      const signParams = {
        orderType: ORDER_TYPE.NORMAL,
        goodsList: [goods],
        payAmount: goods.promoPrice,
        chargeType: CHARGE_TYPE.PAY_AND_SIGN,
        actionType,
      };

      // 如果还未开通连续包月则添加连续包月的参数，走连续包月，若开通了，则只走支付并签约
      // 详细文档：https://hellobike.yuque.com/alphapay/yva5xh/cvb2nrflgoqsqqof
      //         https://hellobike.yuque.com/gzxsb9/iank77/dvd4gzrp5puxudpq?singleDoc#aI5cX
      if (!this.monthlySignIn) {
        // 连续包月chargeType传连续包月的值：1308
        signParams.chargeType = CHARGE_TYPE.PAY_AND_SIGN_MONTHLY;
        // 连续包月下单必传字段，与后端约定好写死为T_RIDE_CARD
        signParams.couponMonthlyScene = 'T_RIDE_CARD';
        // 连续包月免密签约传该渠道号, 固定2309 ，
        signParams.channel = '2309';
        signParams.extension = {
          // 附属签约场景 （目前生效：channel：2309）
          attachSceneType: 'RIDE',
          contractDisplayAccount: this.extraInfo.nikeName || '', // 签约用户的名称
        };
      }
      // 调用签约支付且连续包月组件
      return this.payAndSign(signParams);
    },
    /**
     * 影子卡激活或支付激活
     */
    shadowBuyOnce({ goods }) {
      //  命中到影子卡连续包月的时候，单击左边的激活按钮，取激活影子卡商品的goodsTag和bizScene
      this.productTagForDySign = safeGet(goods, 'payParams.productTagForDySign', this.defaultGoodsTag);
      this.bizSceneForDySign = safeGet(goods, 'payParams.biz_scene', this.defaultBizScene);
      this.activeHandler([goods]);
    },
    /**
      * 影子卡连续包月购买并激活
      */
    async shadowBuyMonthly({ goods, actionType }) {
      //  命中到影子卡连续包月的时候，单击右边的连续包月按钮，取连续包月商品的goodsTag和bizScene
      this.productTagForDySign = safeGet(goods, 'payParams.productTagForDySign', this.defaultGoodsTag);
      this.bizSceneForDySign = safeGet(goods, 'payParams.biz_scene', this.defaultBizScene);
      this.actionType = actionType;
      const res = await this.buyMonthly({ goods, actionType });
      this.shadowPayAndSignSuccessHandle(res);
    },
    /**
     * 去使用
     */
    toUseHandle() {
      // 去使用按钮点击
      SPM.clickButton.platform_tt_card_finish_buttun.call(this);
      // 影子卡激活成功-支付模块点击
      if (this.shadowCardSignType === 'payAndSign' && this.planInfo.hasCard && !this.isShadowCardMonthly) {
        SPM.clickButton.platform_tt_card_finish_activate_pay.call(this);
      }
      // 升级连续包月支付签约完成模块点击
      if (this.actionType === ACTION_TYPE.SHADOW_BUY_MONTHLY) {
        SPM.clickButton.platform_tt_card_finish_monthlyUpdate.call(this);
      }
      // 连续包月升级下-影子卡激活成功模块点击
      if (this.actionType === ACTION_TYPE.SHADOW_PAY_AND_SIGN && this.isShadowCardMonthly) {
        SPM.clickButton.platform_tt_card_finish_monthlyUpdate_shadowcard.call(this);
      }
      // 两轮卡签约完成模块点击
      if (this.actionType === ACTION_TYPE.TWO_WHEEL_CARD_ACTIVE) {
        SPM.clickButton.platform_tt_card_ridecard_finish.call(this);
      }
      if (this.isDouyinMP) {
        if (this.rideBikeHaCode) {
          Toast.show('口令码已复制至剪贴板，请前往哈啰App使用', {
            duration: 5000,
          });
          copyText(this.rideBikeHaCode);
        } else {
          // 如果后端没有返回哈口令，则兜底提示前往哈啰App使用'
          Toast.show('请前往哈啰App使用');
        }
      } else {
        Navigator.go(this.planInfo.redirectLink);
      }
    },
    /**
     * 抖音签约并支付
     */
    async payAndSign(params = {}) {
      // 调起支付并签约组件会有一段时间的等待期间、这个时间禁止用户再次点击支付并签约按钮
      if (this.payAndSignLoading) {
        return {
          success: false,
        };
      }
      this.payAndSignLoading = true;
      // 支付前先创建订单
      const {
        orderType,
        payAmount,
        chargeType,
        goodsList,
        couponMonthlyScene,
        actionType,
        ...signParams
      } = params;
      Loading.show();
      const extraInfo = {
        tikTokBizType: actionType,
        cityCode: this.cityCode,
        systemCode: getSystemCode(),
        planType: this.dataInfo.planType,
        businessType: this.planInfo.businessType,
        monthlySignIn: this.actionType === ACTION_TYPE.SHADOW_BUY_MONTHLY,
      };
      // 影子卡支付并签约，需要传影子卡权益id
      if (this.shadowCardId) {
        extraInfo.userCardGuid = this.shadowCardId;
      }
      const { success, payOrderInfo, msg } = await createOrder({
        orderType,
        payAmount,
        adsource: 'balancevenue',
        chargeType,
        couponMonthlyScene,
        itemList: goodsList,
        hideOrder: safeGet(this.planInfo, 'payParams.hideOrder', false),
        // 额外参数，不影响下单，平台后端需要的参数，交易透传
        extra: extraInfo,
      });
      Loading.close();
      // 下单失败，toast提示，阻止后续流程
      if (!success) {
        this.payAndSignLoading = false;
        Toast.show(msg);
        return {
          success,
        };
      }
      // 调用抖音免密签约并支付
      const callRes = await callDouYinPayAndSign({
        ...payOrderInfo,
        signChannel: this.dataInfo.signChannel || 'douyin',
        bizScene: this.bizSceneForDySign,
        productTagForDySign: this.productTagForDySign,
        signMustPay: safeGet(this.planInfo, 'payParams.signMustPay', true),
        ...(signParams || {}),
      });
      this.payAndSignLoading = false;
      // 影子卡支付并签约或者影子卡连续包月或者不补贴复购之后，还需要去激活，不能直接走 payWithSignSuccess
      const { SHADOW_PAY_AND_SIGN, SHADOW_BUY_MONTHLY, NO_SUBSIDY_REPURCHASE } = ACTION_TYPE;
      if (actionType === SHADOW_PAY_AND_SIGN || actionType === SHADOW_BUY_MONTHLY
          || actionType === NO_SUBSIDY_REPURCHASE) {
        return callRes;
      }
      if (callRes.success) {
        this.payWithSignSuccessHandle({
          showToast: true,
          actionType,
        }); // 免签成功逻辑处理
      } else {
        this.signIn = false;
      }
      // 支付签约模块点击
      SPM.clickButton.platform_tt_card_gott.call(this);
      return callRes;
    },
    /**
     * 获取 bizDefinedParam 参数
     */
    getBizDefinedParam(actionType) {
      const { cityCode, userNewId } = this;
      const systemCode = getSystemCode();

      if (actionType === ACTION_TYPE.TWO_WHEEL_CARD_ACTIVE) {
        // 两轮卡激活场景
        return {
          userNewId: userNewId || '',
          cardGuid: this.cardGuid || '',
          actType: ACTION_TYPE.TWO_WHEEL_CARD_ACTIVE,
        };
      }
      // 其他场景
      return {
        userNewId: userNewId || '',
        systemCode: systemCode || '',
        cityCode: cityCode || '',
        businessType: this.planInfo.businessType || '',
        userCardGuid: this.shadowCardId || '',
        planType: 'tiktok_sign',
        actType: actionType,
      };
    },

    /**
     * 激活卡处理逻辑
     */
    async activeHandler(goodsList) {
      // 抖音小程序不支持激活操作，提示前往哈啰app
      if (this.isDouyinMP) {
        if (this.extraInfo.haCode) {
          copyText(this.extraInfo.haCode);
          Toast.show('口令码已复制至剪贴板，请前往哈啰App激活');
        } else {
          Toast.show('请前往哈啰App激活');
        }
        return;
      }

      // 调用抖音仅免密支付签约组件
      let callRes = {};
      if (this.shadowCardSignType === 'sign') {
        // 用户行为：影子卡仅签约，则设置actionType为影子卡仅激活
        if (this.cardGuid) {
          this.actionType = ACTION_TYPE.TWO_WHEEL_CARD_ACTIVE;
        } else {
          this.actionType = ACTION_TYPE.ACTIVE;
        }

        const bizDefinedParam = this.getBizDefinedParam(this.actionType);
        // 影子卡仅签约
        callRes = await callDouYinSign({
          businessType: this.planInfo.businessType,
          extras: {
            goodsTag: this.productTagForDySign,
            bizScene: this.bizSceneForDySign,
            bizDefinedParam: JSON.stringify(bizDefinedParam),
          },
        });
      } else {
        const shadowGood = (goodsList || [])[0];
        if (!shadowGood) {
          Toast.show('下单失败，缺少商品信息');
          return;
        }
        // 用户行为：影子卡支付并签约，则设置actionType为影子卡支付并签约
        this.actionType = ACTION_TYPE.SHADOW_PAY_AND_SIGN;
        // 影子卡支付并签约
        callRes = await this.payAndSign({
          orderType: ORDER_TYPE.NORMAL,
          goodsList: goodsList || [],
          payAmount: shadowGood.promoPrice,
          chargeType: CHARGE_TYPE.PAY_AND_SIGN,
          actionType: ACTION_TYPE.SHADOW_PAY_AND_SIGN,
        });
      }
      // 签约组件调用成功
      this.shadowPayAndSignSuccessHandle(callRes);
    },
    /**
     * 影子卡支付或签约组件调用成功处理
     */
    async shadowPayAndSignSuccessHandle(callRes) {
      if (callRes.success) {
        Loading.show('激活中');
        // 查询签约结果
        const signRes = await queryDouYinSignResult({
          planType: this.dataInfo.planType,
          timeout: (this.planInfo.maxLoadingTime || 5000) / 1000,
          interval: this.planInfo.delayTime || 500,
        });
        Loading.close();
        if (signRes.signIn) {
          // 签约成功后调用激活方法
          this.starActiveCard();
        } else {
          Toast.show('签约超时');
          this.signIn = false;
        }
      } else {
        this.signIn = false;
        const errorCode = safeGet(callRes.error, 'response.data.errorCode', null);
        // 抖音仅签约失败埋点上报
        SPM.clickButton.platform_tt_card_activate.call(this, errorCode);
      }
    },
    /**
     * 激活卡
     */
    async starActiveCard() {
      // 调用激活卡片接口
      const { success, msg } = await activeCardHelper({
        planType: safeGet(this, 'dataInfo.planType', 'tiktok_sign'),
        systemCode: getSystemCode(),
        userCardGuid: this.shadowCardId,
        businessType: this.planInfo.businessType,
        // 连续包月激活时，传入true
        monthlySignIn: this.actionType === ACTION_TYPE.SHADOW_BUY_MONTHLY,
        cardGuid: this.cardGuid,
        isRepurchase: this.planInfo.sceneType === SCENE_TYPE.NO_SUBSIDY_REPURCHASE,
      });
      if (success) {
        Toast.show('激活成功');
        // 免签成功逻辑处理
        this.payWithSignSuccessHandle({
          showToast: false,
          actionType: this.actionType,
        });
      } else {
        Loading.close();
        Toast.show(msg || '激活失败');
      }
    },

    /**
     * 动态组件业务场景点击事件
     */
    senceHandler() {
      switch (this.planInfo.sceneType) {
        case SCENE_TYPE.NO_SUBSIDY_REPURCHASE:
          this.noSubsidyRepurchaseHandler({
            goodsList: this.planInfo.goodsList,
            actionType: ACTION_TYPE.NO_SUBSIDY_REPURCHASE,
          });
          break;
        default:
          break;
      }
    },

    async noSubsidyRepurchaseHandler({ goodsList, actionType }) {
      this.actionType = actionType;
      // 不补贴复购页面购卡优惠模块点击
      SPM.clickButton.platform_tt_card_noSubsidyRepurchase_discount.call(this);
      const shadowGood = (goodsList || [])[0];
      if (!shadowGood) {
        return Toast.show('下单失败，缺少商品信息');
      }
      const callRes = await this.payAndSign({
        orderType: ORDER_TYPE.NORMAL,
        goodsList: goodsList || [],
        payAmount: shadowGood.promoPrice,
        chargeType: CHARGE_TYPE.PAY_AND_SIGN,
        actionType,
      });
      // 透传需要刷新页面状态的标识
      this.shadowPayAndSignSuccessHandle(callRes);
      return callRes;
    },
    /**
     * 签约并支付或者签约不支付的回调
     */
    payWithSignSuccessHandle(params) {
      const { showToast, actionType } = params;
      if (showToast) {
        Toast.show('领取成功');
      }
      this.displayDefault = false;
      this.signIn = true;
      SPM.pageView.platform_tt_card_finish.call(this);
      switch (actionType) {
        case ACTION_TYPE.NORMAL_PAY_AND_SIGN:
          // 支付并签约成功模块曝光
          SPM.moduleExpose.platform_tt_card_finish_paid.call(this);
          break;
        case ACTION_TYPE.ACTIVE:
          //  影子卡激活成功模块曝光
          SPM.moduleExpose.platform_tt_card_finish_activate.call(this);
          break;
        case ACTION_TYPE.SHADOW_PAY_AND_SIGN:
          if (this.isShadowCardMonthly) {
            // 连续包月升级下-影子卡激活成功模块曝光
            SPM.moduleExpose.platform_tt_card_finish_monthlyUpdate_shadowcard.call(this);
          } else {
            //  影子卡激活成功模块曝光
            SPM.moduleExpose.platform_tt_card_finish_activate_pay.call(this);
          }
          break;
        case ACTION_TYPE.BUY_ONE_MONTH:
          // 单独购买一个月成功模块曝光
          SPM.moduleExpose.platform_tt_card_finish_monthlySinglePaid.call(this);
          break;
        case ACTION_TYPE.BUY_MONTHLY:
          // 连续包月成功模块曝光
          SPM.moduleExpose.platform_tt_card_finish_monthlyPaid.call(this);
          break;
        case ACTION_TYPE.SHADOW_BUY_MONTHLY:
          // 升级连续包月支付签约完成模块曝光
          SPM.moduleExpose.platform_tt_card_finish_monthlyUpdate.call(this);
          break;
        case ACTION_TYPE.TWO_WHEEL_CARD_ACTIVE:
          // 两轮卡激活成功模块曝光
          SPM.moduleExpose.platform_tt_card_ridecard_finish.call(this);
          break;
        case ACTION_TYPE.NO_SUBSIDY_REPURCHASE:
          // 不补贴复购页面购卡支付成功曝光
          SPM.moduleExpose.platform_tt_card_noSubsidyRepurchase_pay_success.call(this);
          // 不补贴复购页面购卡支付成功模块点击
          SPM.clickButton.platform_tt_card_noSubsidyRepurchase_pay_success.call(this);
          break;
        default:
          break;
      }
      // 后续业务新增的场景类需求都会添加到SCENE_TYPE中，统一标记为已激活场景
      if (this.hasScene) {
        this.planInfo.sceneType = 'ACTIVITED_SCENE';
      }
    },
    /**
     * 跳转自动续费协议
     */
    goRenewal() {
      commonGoLink(
        PROTOCOL_URL.RENEWAL,
        { isRuleLink: true },
      );
    },
    /**
     * 跳转哈啰会员服务协议
     */
    goMember() {
      commonGoLink(
        PROTOCOL_URL.MEMBER,
        { isRuleLink: true },
      );
    },
    handlePageVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.getRetainPopupWindow();
      }
    },
    /**
     * 获取挽留弹窗
     */
    getRetainPopupWindow() {
      if (this.displayImgs.retainPopupImg) {
        this.retainPopupImg = this.displayImgs.retainPopupImg;

        if (this.retainPopupImg) {
          const hasShownToday = Storage.getItem('retainPopup_dailyShown');
          if (!hasShownToday && !this.signIn) {
            Storage.setItem('retainPopup_dailyShown', true, dayjs().endOf('day').toDate());
            if (window.history && window.history.pushState) {
              window.history.pushState('', '', document.URL);
            }
          } else {
            this.retainPopupImg = null;
          }
        }
      }
    },
    /**
     * 显示挽留弹窗
     */
    handlePopstate() {
      if (this.displayDefault) {
        return;
      }
      if (this.retainPopupImg && !this.showRetainDialog && !this.signIn) {
        this.showRetainDialog = true;
        // 离开页面挽留弹窗模块曝光
        SPM.moduleExpose.platform_tt_card_retention.call(this);
      }
    },
    /**
     * 关闭挽留弹窗，并退出当前页面
     */
    handleBack() {
      // 离开页面挽留弹窗 残忍离开按钮模块点击
      SPM.clickButton.platform_tt_card_retention.call(this, '残忍离开');
      this.showRetainDialog = false;
      if (env.isEasyBikeApp) {
        Native.closeWebView();
      }
    },
    handleCloseRetain() {
      this.showRetainDialog = false;
      // 离开页面挽留弹窗 残忍离开按钮模块点击
      SPM.clickButton.platform_tt_card_retention.call(this, '前往开通');
    },
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: 'MFYuanHei';
  src: url('https://m.hellobike.com/167f3e48_MFYuanHei_Noncommercial-Regular.otf') format('truetype');
  font-weight: medium;
}

.container {
  width: 100%;
  min-height: 100vh;
  display: flow-root;
  background: linear-gradient(176.53deg, #5cd3ff 1.464rem, #e1f7ff 2.826rem, #e1f7ff 6.897rem);

  &.is-shadow-monthly-card {
    background: linear-gradient(180deg, #b5f2fa 0%, #b5f2fa 2.88rem, #caf4fd 6.897rem);
  }

  .bg-container {
    width: 100%;
    // height: 2.43rem;
    height: 3.12rem;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center top;
    position: absolute;
    left: 0;
    top: 0;
  }

  .middle-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-top: 2.43rem;

    .sign-in-action {
      color: #08f;
      background-color: #e6f4ff;
      width: 2.67rem;
      height: 0.52rem;
      line-height: 0.52rem;
      font-size: 0.18rem;
      text-align: center;
      margin: 0 auto;
      border: 1px solid #08f;
      border-radius: 0.52rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 2.5rem;
    }
  }

  .notice {
    width: 3.75rem;
    margin-top: 0.2rem;
  }

  .shadow-notice {
    display: block;
    width: 3.43rem;
    margin: 0.18rem auto;
  }

  &.is-douyin-mp {
    .bg-container {
      height: 2.62rem;
    }

    .middle-container {
      margin-top: 1.92rem;
    }
  }

  .subsidy-price-container {
    margin-top: 0.07rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .subsidy {
      position: relative;

      .reduce-num {
        position: absolute;
        width: 1rem;
        // background: green;
        top: 0.22rem;
        left: 1.32rem;
        text-align: center;
        font-size: 0.12rem;
        color: #fd1d37;
        font-weight: 600;

        .num {
          font-size: 0.2rem;
          font-weight: 700;
          font-family: 'DINAlternate', sans-serif;
        }
      }

      img.subsidy-pic {
        width: 3.12rem;
        height: 1.06rem;
      }
    }

    .btn-wrapper {
      position: absolute;
      bottom: -0.2rem;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 3.35rem;
      height: 0.6rem;
      border-radius: 0.32rem;
      z-index: 1;

      &.normal-btn {
        border: 0.01rem solid #f72e39;
        background:
          linear-gradient(
            106.2deg,
            #ff41b9 -29.76%,
            #ff3c70 20.55%,
            #ff4c31 77.01%,
            #ffba43 109.99%
          );
      }

      &.special-btn {
        background: #08f;
      }
    }

    .text-wrapper {
      height: 0.6rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .price-wrapper {
        display: flex;
        flex-direction: row;
        align-items: baseline;
      }

      .btn-price-text,
      .btn-inform-text,
      .btn-active-text,
      .go-cycle {
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        text-align: center;
        color: #fff;
        white-space: nowrap;
        font-weight: 400;
      }

      .btn-active-text {
        font-size: 0.2rem;
        font-weight: 600;
        margin-bottom: 0.03rem;
      }

      .btn-price-text {
        font-size: 0.24rem;
        text-align: center;
        font-weight: 600;

        .fix-text {
          font-size: 0.18rem;
        }

        // &::before {
        //   content: '补贴后 仅需';
        //   font-size: 0.18rem;
        // }

        // &::after {
        //   content: '元抢';
        //   font-size: 0.18rem;
        // }
      }

      .btn-inform-text {
        font-size: 0.12rem;
        letter-spacing: 0.005rem;
        font-weight: 400;
        height: 0.17rem;
        line-height: 0.17rem;
      }

      .go-cycle {
        font-size: 0.18rem;
        font-weight: 500;
      }
    }
  }

  .monthly-box {
    margin-top: 0.24rem;

    .button-content {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .privacy-policy {
      font-size: 0.11rem;
      color: #879099;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.1rem;
    }
  }

  .shadow-monthly-box {
    margin-top: -0.8rem;
    position: relative;
    z-index: 10;

    .button-content {
      display: flex;
      align-items: center;

      .left-button {
        margin-left: 0.3rem;
      }

      .right-button {
        margin-left: 0.1rem;
      }
    }

    .privacy-policy {
      margin-top: 0.4rem;
    }
  }

  .shadow-monthly-tips {
    margin: 0.53rem auto 0;
    background: rgba(157, 242, 255, 0.7);
    border-radius: 0.12rem;
    width: 3.34rem;
    padding: 0.12rem;

    .title {
      font-size: 0.12rem;
      font-weight: 600;
      color: #242729;
      margin-bottom: 0.06rem;
    }

    .text {
      font-size: 0.12rem;
      color: #242729;
      margin-bottom: 0.03rem;

      span {
        color: #879099;
      }
    }
  }

  .active-last-date {
    color: #879099;
    text-align: center;
    margin-top: 0.26rem;
    font-size: 0.12rem;
  }
}
</style>
